import React from "react";

import { Modal, Button } from "react-bootstrap";
import { X, FileEarmarkExcel } from "react-bootstrap-icons";


export const ReceiptNotFound = ({ show, onClose, receiptNumber }) => {

    return (
        <Modal show={show} size="md" aria-labelledby="contained-modal-title-vcenter" centered style={{ fontSize: "14px" }}>
            <Modal.Header closeButton className="text-danger">
                <FileEarmarkExcel size={20} /> {" "} Receipt Not Found
            </Modal.Header>
            <Modal.Body>
                <p>
                    Receipt number: <b> {receiptNumber} </b> was not found. <br/>
                    <br/>
                    Ensure that the correct receipt number is entered in the right format: <i>'ERGxxxxxxxxxx'</i>.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onClose}>
                    <X /> {" "} Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};